module.exports = __webpack_public_path__ + "static/fonts/SentyTEA.a472dadb.woff2";